import axios from 'axios'
import {Notify} from 'vant'


// 获取config.js中配置的请求地址
let config = JSON.parse(localStorage.dynamicConfig)
let baseUrl = config.baseUrl
// let baseUrl = ''


// 创建axios实例
const service = axios.create({
	// baseURL: baseUrl,
	timeout: 5000 // 请求超时
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		//设置请求头
		// if (store.getters.token) {
		// 	config.headers['token'] = getToken()
		// }

		return config
	},
	error => {
		// 处理请求错误
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response

		// 如果状态码不是200，则判断为错误.
		if (res.status != 200) {
			Notify({
				type: 'danger',
				message: res.msg || 'Error',
				duration: 5 * 1000
			})

			return Promise.reject(new Error(res.msg || 'Error'))
		} else {
			return res
		}
	},
	error => {
		console.log('err' + error) // for debug
		Notify({
			type: 'danger',
			message: error.msg,
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

const myRequest = function({method, url, data}) {
	// if( url && url.indexOf("http") === -1 ) {
	// 	url = baseUrl + url
	// }

	if (method == "GET") {
		url += "?"
	}
	let formData = new FormData()

	for (let k in data) {
		formData.append(k, data[k])
		if (method == "GET") {
			url += `${k}=${data[k]}&`
		}
	}

	if (method == "GET") {
		url = url.slice(0, url.length - 1)
	}

	return service({url, method, data: formData})
}

//封装http请求
const http = {
	get: (url, data) => myRequest({url, method: "GET", data}),
	post: (url, data) => myRequest({url, method: "POST", data}),
	baseUrl: baseUrl.slice(0, baseUrl.length - 1)
}

export default http

